/* TODO: t() */
import React, { Component } from 'react';
import { View, StyleSheet, Image } from 'react-native';

import { Icon, Text, ModalFull } from '../uiold';
import { themeColors } from '../uiold/Constants';
import { formatDateFull } from '../../support/DateTime';
import HomePage from './HomePage';

import Thumbnail from '../Preview/Thumbnail';
import { DocumentTypes, ImageTypes } from '../../core/constants/MimeTypes';
import createViewComponent from '../../support/rn-web/createViewComponent';
import RawHTMLBlock from '../uiold/RawHTMLBlock';
import MyInfoPage from './MyInfoPage';

import { Attachment } from '../../types/shared/FileUpload';
import { VendorAccount } from '../../types/shared/VendorAccount';
import { VendorPortalPage } from '../../types/shared/VendorPortalPage';
import {
  getDownloadURL,
  getFileURL,
  toFile,
} from '../../support/helpers/Files';

const LinkView = createViewComponent({
  tagName: 'a',
  additionalProps: {
    download: true,
  },
});

type Props = {
  vendorAccount: VendorAccount | null | undefined;
  marketAccountID: string;
  toggleLoginModal: (arg0: boolean) => void;
  marketName: string;
  toggleMyInfo: (value: boolean) => void;
  displayMyInfo: boolean;
  displayHomepage: boolean;
  selectedVendorPortalPage: VendorPortalPage | null | undefined;
};

type State = {
  isModal: boolean;
  activeFile: Attachment | null | undefined;
};

class Content extends Component<Props, State> {
  state: State = {
    activeFile: null,
    isModal: false,
  };

  render() {
    // if (this.props.isLoading) {
    //   // TODO: Use a loading indicator.
    //   return <View />;
    // }
    return (
      <View style={styles.rowFlexed}>
        {this._renderPageDetails()}
        {this._renderModalPreview()}
      </View>
    );
  }

  _renderPageDetails = () => {
    let {
      displayMyInfo,
      displayHomepage,
      marketName,
      toggleLoginModal,
      vendorAccount,
      toggleMyInfo,
      selectedVendorPortalPage,
    } = this.props;
    if (selectedVendorPortalPage) {
      return (
        <View style={styles.detail}>
          <Text type="heading" style={styles.detailTitle}>
            {selectedVendorPortalPage.title}
          </Text>
          <RawHTMLBlock
            content={selectedVendorPortalPage?.content ?? ''}
            style={{ textAlign: 'justify' }}
          />
          {selectedVendorPortalPage.attachments &&
            selectedVendorPortalPage.attachments.length > 0 && (
              <View style={styles.attachmentPreview}>
                {selectedVendorPortalPage.attachments.map((attachment, idx) => {
                  let file = toFile(attachment);
                  let href = getDownloadURL(file);
                  return (
                    <View key={idx}>
                      <View style={styles.previewWrapper}>
                        <Thumbnail
                          width={180}
                          height={135}
                          file={file}
                          onPreview={() => {
                            this._onModalPreview(attachment);
                          }}
                        />
                        <Text
                          style={styles.fileName}
                          type="label"
                          numberOfLines={1}
                        >
                          {attachment.fileName}
                        </Text>
                      </View>
                      <LinkView
                        href={href}
                        download={true}
                        style={styles.buttonIcon}
                      >
                        <Icon name="download" size="M" />
                      </LinkView>
                    </View>
                  );
                })}
              </View>
            )}
          <View style={styles.dateContainer}>
            <Text style={styles.itemDate}>
              Last modified on{' '}
              {formatDateFull(selectedVendorPortalPage.lastModified)}
            </Text>
          </View>
        </View>
      );
    } else if (displayHomepage) {
      return (
        <HomePage marketName={marketName} toggleLoginModal={toggleLoginModal} />
      );
    } else if (displayMyInfo && vendorAccount) {
      return (
        <MyInfoPage vendorAccount={vendorAccount} toggleMyInfo={toggleMyInfo} />
      );
    }
  };

  // TODO: This logic seems to be duplicated from FileUpload; Abstract this.
  _renderModalPreview = () => {
    let { activeFile, isModal } = this.state;
    if (!activeFile || !isModal) {
      return;
    }
    let file = activeFile;
    let modalPreview = (content: ReactElement) => {
      return (
        <ModalFull
          isVisible={isModal}
          title={file.fileName || 'File Preview'}
          onClose={this._showModalPDF}
        >
          {content}
        </ModalFull>
      );
    };
    if (ImageTypes[file.fileType]) {
      return modalPreview(
        <View style={styles.imagePreview}>
          <Image
            source={{ uri: getFileURL(toFile(file), { size: 'large' }) }}
            style={{ width: 800, height: 600 }}
            resizeMode="contain"
            resizeMethod="scale"
          />
        </View>,
      );
    } else if (DocumentTypes[file.fileType] === 'pdf') {
      return modalPreview(
        <embed
          type={file.fileType}
          src={getFileURL(toFile(file))}
          style={{ flex: 1, maxHeight: 800 }}
        />,
      );
    } else {
      let href = getDownloadURL(toFile(file));
      return modalPreview(
        <LinkView href={href} download={true} style={styles.iconDownload}>
          <Icon name="download" size="XXL" />
          <Text style={{ marginTop: 100 }}>
            {`Sorry this file can't be previewed, click icon for download. `}
          </Text>
        </LinkView>,
      );
    }
  };

  _onModalPreview = (file: Attachment) => {
    this.setState((state) => {
      return { isModal: !state.isModal, activeFile: file };
    });
  };

  _showModalPDF = () => {
    this.setState((state) => {
      return { isModal: !state.isModal };
    });
  };
}

let styles = StyleSheet.create({
  rowFlexed: {
    flexDirection: 'row',
    flex: 1,
  },
  buttonIcon: {
    position: 'absolute',
    backgroundColor: themeColors.white,
    zIndex: 2,
    top: 10,
    right: 10,
    opacity: 0.7,
    borderRadius: 2,
    marginHorizontal: 2,
  },
  dateContainer: {
    marginTop: 25,
    flex: 1,
    alignSelf: 'flex-end',
  },
  itemDate: {
    fontSize: 13,
    color: themeColors.darkGrey,
  },
  detail: {
    flex: 1,
    overflow: 'scroll',
    backgroundColor: themeColors.white,
    paddingVertical: 70,
    paddingHorizontal: 110,
  },
  detailTitle: {
    marginBottom: 20,
    fontWeight: '600',
  },
  fileName: {
    position: 'absolute',
    flex: 1,
    bottom: 5,
    width: 150,
    padding: 2,
    borderWidth: 0,
    backgroundColor: themeColors.grey,
    textAlign: 'center',
  },
  attachmentPreview: {
    marginTop: 25,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  previewWrapper: {
    padding: 5,
    alignItems: 'center',
  },
  iconDownload: {
    backgroundColor: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  imagePreview: {
    backgroundColor: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
});

export default Content;
